export default "/images/close.png?361ad9a0e632f77b39167e620f28d5e5";